<div class="content d-flex flex-column">
  <router-outlet></router-outlet>
</div>
